<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-data-table
				class="elevation-1"
				:headers="headers"
				:items="countries"
				hide-default-footer
				:loading="loading"
				:items-per-page="-1"
				show-expand
				expand-icon="mdi-chevron-triple-down"
				item-key="id"
				disable-sort
				@item-expanded="fetchRegions"
			>
				<template #top>
					<v-toolbar flat>
						<v-toolbar-title class="px-4">جدول الأماكن</v-toolbar-title>
						<v-divider insert vertical></v-divider>
						<v-spacer></v-spacer>
						<v-btn color="green" class="white--text" :disabled="!privs.new" @click="addCountry">
							إضافة دولة جديدة
							<v-icon right>mdi-earth-plus</v-icon>
						</v-btn>
					</v-toolbar>
				</template>

				<template #expanded-item="{ item: country }">
					<td :colspan="headers.length + 1" class="px-0">
						<v-data-table
							class="elevation-1"
							:headers="headers"
							:items="country.regions"
							hide-default-footer
							:hide-default-header="$vuetify.breakpoint.smAndUp"
							:loading="!country.regionsLoaded"
							:items-per-page="-1"
							show-expand
							expand-icon="mdi-chevron-double-down"
							item-key="id"
							disable-sort
							@item-expanded="fetchCities"
						>
							<template #expanded-item="{ item: region }">
								<td :colspan="headers.length + 1" class="px-0">
									<v-data-table
										class="elevation-1"
										:headers="headers"
										:items="region.cities"
										hide-default-footer
										:hide-default-header="$vuetify.breakpoint.smAndUp"
										:loading="!region.citiesLoaded"
										:items-per-page="-1"
										show-expand
										item-key="id"
										disable-sort
										@item-expanded="fetchPlaces"
									>
										<template #expanded-item="{ item: city }">
											<td :colspan="headers.length + 1" class="px-0">
												<v-data-table
													class="elevation-1"
													:headers="headers2"
													:items="city.places"
													hide-default-footer
													:hide-default-header="$vuetify.breakpoint.smAndUp"
													:loading="!city.placesLoaded"
													:items-per-page="-1"
													item-key="id"
													disable-sort
												>
													<template #[`item.icon`]="{ item: place }">
														<v-icon v-if="place.isHospital">mdi-hospital-building</v-icon>
														<v-icon v-else>mdi-city</v-icon>
													</template>

													<template #[`item.actions`]="{ item: place }">
														<v-tooltip bottom>
															<template #activator="{ on }">
																<v-btn :disabled="!privs.manage || actionLoading" icon color="primary" v-on="on" @click="editPlace(place)">
																	<v-icon>mdi-domain</v-icon>
																</v-btn>
															</template>

															<span>تحرير المكان</span>
														</v-tooltip>

														<v-tooltip bottom>
															<template #activator="{ on }">
																<v-btn :disabled="!privs.delete || actionLoading" icon color="error" v-on="on" @click="removePlace(city, place)">
																	<v-icon>mdi-domain-remove</v-icon>
																</v-btn>
															</template>

															<span>حذف المكان</span>
														</v-tooltip>
													</template>
												</v-data-table>
											</td>
										</template>

										<template #[`item.actions`]="{ item: city }">
											<v-tooltip bottom>
												<template #activator="{ on }">
													<v-btn :disabled="!privs.new || actionLoading" icon color="primary" v-on="on" @click="addPlace(country, region, city)">
														<v-icon>mdi-domain-plus</v-icon>
													</v-btn>
												</template>

												<span>إضافة مكان</span>
											</v-tooltip>
											
											<v-tooltip bottom>
												<template #activator="{ on }">
													<v-btn :disabled="!privs.manage || actionLoading" icon color="primary" v-on="on" @click="editCity(city)">
														<v-icon>mdi-map-marker</v-icon>
													</v-btn>
												</template>

												<span>تحرير المدينة</span>
											</v-tooltip>

											<v-tooltip bottom>
												<template #activator="{ on }">
													<v-btn :disabled="!privs.delete || actionLoading" icon color="error" v-on="on" @click="removeCity(city, region)">
														<v-icon>mdi-map-marker-remove</v-icon>
													</v-btn>
												</template>

												<span>حذف المدينة</span>
											</v-tooltip>
										</template>
									</v-data-table>
								</td>
							</template>

							<template #[`item.actions`]="{ item: region }">
								<v-tooltip bottom>
									<template #activator="{ on }">
										<v-btn :disabled="!privs.manage || actionLoading" icon color="primary" v-on="on" @click="addCity(country, region)">
											<v-icon>mdi-map-marker-plus</v-icon>
										</v-btn>
									</template>

									<span>إضافة مدينة</span>
								</v-tooltip>

								<v-tooltip bottom>
									<template #activator="{ on }">
										<v-btn :disabled="!privs.manage || actionLoading" icon color="primary" v-on="on" @click="editRegion(region)">
											<v-icon>mdi-map</v-icon>
										</v-btn>
									</template>

									<span>تحرير المنطقة</span>
								</v-tooltip>

								<v-tooltip bottom>
									<template #activator="{ on }">
										<v-btn :disabled="!privs.delete || actionLoading" icon color="error" v-on="on" @click="removeRegion(region)">
											<v-icon>mdi-map-minus</v-icon>
										</v-btn>
									</template>

									<span>حذف المنطقة</span>
								</v-tooltip>
							</template>
						</v-data-table>
					</td>
				</template>

				<template #[`item.actions`]="{ item: country }">
					<v-tooltip bottom>
						<template #activator="{ on }">
							<v-btn :disabled="!privs.new || actionLoading" icon color="primary" v-on="on" @click="addRegion(country.id)">
								<v-icon right>mdi-map-plus</v-icon>
							</v-btn>
						</template>

						<span>إضافة منطقة</span>
					</v-tooltip>

					<v-tooltip bottom>
						<template #activator="{ on }">
							<v-btn :disabled="!privs.manage || actionLoading" icon color="primary" v-on="on" @click="editCountry(country)">
								<v-icon>mdi-earth</v-icon>
							</v-btn>
						</template>

						<span>تحرير الدولة</span>
					</v-tooltip>

					<v-tooltip bottom>
						<template #activator="{ on }">
							<v-btn :disabled="!privs.delete || actionLoading" icon color="error" v-on="on" @click="removeCountry(country)">
								<v-icon>mdi-earth-minus</v-icon>
							</v-btn>
						</template>

						<span>حذف الدولة</span>
					</v-tooltip>
				</template>
			</v-data-table>
		</v-container>

		<v-dialog v-model="showAddNewCountry" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إضافة دولة جديدة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid1">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="countryID"
									outlined
									label="معرف الدولة"
									:rules="[rules.required, rules.id]"
									dir="ltr"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newName"
									outlined
									label="الدولة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid1" :loading="actionLoading" @click="addNewCountry">إضافة</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showAddNewRegion" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إضافة منطقة جديدة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid2">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="countryID"
									outlined
									label="معرف الدولة"
									:rules="[rules.required]"
									dir="ltr"
									disabled
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="regionID"
									outlined
									label="معرف المنطقة"
									:rules="[rules.required, rules.id]"
									dir="ltr"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newName"
									outlined
									label="المنطقة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid2" :loading="actionLoading" @click="addNewRegion">إضافة</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showAddNewCity" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إضافة مدينة جديدة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid3">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="regionID"
									outlined
									label="معرف المنطقة"
									:rules="[rules.required]"
									dir="ltr"
									disabled
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="cityID"
									outlined
									label="معرف المدينة"
									:rules="[rules.required, rules.id]"
									dir="ltr"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newName"
									outlined
									label="المدينة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid3" :loading="actionLoading" @click="addNewCity">إضافة</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showAddNewPlace" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إضافة مكان جديد</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid7">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="cityID"
									outlined
									label="معرف المدينة"
									:rules="[rules.required]"
									dir="ltr"
									disabled
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newName"
									outlined
									label="اسم المكان"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-switch v-model="isHospital" label="مستشفى" hide-details class="my-0 py-0"></v-switch>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid7" :loading="actionLoading" @click="addNewPlace">إضافة</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showEditCountry" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحرير اسم دولة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid4">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newName"
									outlined
									label="الدولة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid4" :loading="actionLoading" @click="updateCountry">تحرير</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showEditRegion" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحرير اسم منطقة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid5">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newName"
									outlined
									label="المنطقة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid5" :loading="actionLoading" @click="updateRegion">تحرير</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showEditCity" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحرير اسم مدينة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid6">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newName"
									outlined
									label="المدينة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid6" :loading="actionLoading" @click="updateCity">تحرير</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showEditPlace" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحرير مكان</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid8">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newName"
									outlined
									label="اسم المكان"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-switch v-model="isHospital" label="مستشفى" hide-details class="my-0 py-0"></v-switch>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid8" :loading="actionLoading" @click="updatePlace">تحرير</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<app-confirmation-dialog ref="confirm"></app-confirmation-dialog>
	</div>
</template>

<script>
import client from "@/client";
import clientNotifier from "@/clientNotifier";
import rulesMixin from "@/mixins/rules-mixin";

export default {
	components: {
		AppConfirmationDialog: () => import(/* webpackChunkName: "app-confirmation-dialog" */ "@/components/AppConfirmationDialog"),
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			privs: {},
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					disabled: false,
					to: { name: "dashboard-home" }
				},
				{ text: "الأماكن", disabled: true }
			],
			headers: [
				{
					text: "الدولة",
					value: "country"
				},
				{
					text: "المنطقة",
					value: "region"
				},
				{
					text: "المدينة",
					value: "city"
				},
				{
					text: "المكان",
					value: "place"
				},
				{
					text: "العمليات",
					value: "actions",
					align: "end"
				}
			],
			headers2: [
				{
					text: "مدينة",
					value: "icon"
				},
				{
					text: "الدولة",
					value: "country"
				},
				{
					text: "المنطقة",
					value: "region"
				},
				{
					text: "المدينة",
					value: "city"
				},
				{
					text: "المكان",
					value: "place"
				},
				{
					text: "العمليات",
					value: "actions",
					align: "end"
				}
			],
			loading: true,
			actionLoading: false,
			countries: [],
			valid1: false,
			valid2: false,
			valid3: false,
			valid4: false,
			valid5: false,
			valid6: false,
			valid7: false,
			valid8: false,
			
			showAddNewCountry: false,
			showAddNewRegion: false,
			showAddNewCity: false,
			showAddNewPlace: false,

			newName: null,
			countryID: null,
			regionID: null,
			cityID: null,
			placeID: null,

			addingCityToRegion: null,
			addingToCountry: null,
			addingToCity: null,

			edittingCountry: null,
			edittingRegion: null,
			edittingCity: null,
			edittingPlace: null,

			showEditCountry: null,
			showEditRegion: null,
			showEditCity: null,
			showEditPlace: null,

			isHospital: true,
			locationLink: null,
		};
	},
	mounted() {
		this.getPrivileges();
		this.getCountries();
	},
	methods: {
		getPrivileges() {
			client
				.get("/api/privilege/placesIcons")
				.then(response => {
					console.log(response);
					this.privs = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCountries() {
			client
				.get("/api/location/countries")
				.then(response => {
					this.countries = response.data.data.map(country => {
						country.country = country.name;
						country.id = country.countryID;
						country.regionsLoaded = false;
						country.regions = [];
						return country;
					});
					this.loading = false;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		async getRegions(countryID, country) {
			await client
				.post("/api/location/countryregions", { countryID: countryID })
				.then(response => {
					country.regions = response.data.data.map(region => {
						region.id = region.regionID;
						region.country = country.country;
						region.region = region.name;
						region.citiesLoaded = false;
						region.cities = [];
						return region;
					});
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		async getCities(regionID, region) {
			await client
				.post("/api/location/regioncities", { regionID: regionID })
				.then(response => {
					// this.cities = response.data.data;
					region.cities = response.data.data.map(city => {
						city.id = city.cityID;
						city.country = region.country;
						city.region = region.name;
						city.city = city.name;
						city.placesLoaded = false;
						city.places = [];
						return city;
					});
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		async getPlaces(cityID, city) {
			await client
				.get("/api/location/cityplaces/" + cityID)
				.then(response => {
					// this.cities = response.data.data;
					city.places = response.data.data.map(place => {
						// place.id = place.placeID;
						place.country = city.country;
						place.region = city.region;
						place.city = city.city;
						place.place = place.name;
						return place;
					});
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		async fetchRegions(item) {
			if(item.value) {
				var country = item.item;
				if(country.regionsLoaded == false){
					await this.getRegions(country.id, country);
					country.regionsLoaded = true;
					country.region = country.regions.length;
					console.log(country.regions);
					console.log('country');
				}
			}
		},
		async fetchCities(item) {
			if(item.value) {
				var region = item.item;
				if(region.citiesLoaded == false) {
					await this.getCities(region.id, region);
					region.citiesLoaded = true;
					region.city = region.cities.length;
					console.log('region');
				}
			}
		},
		async fetchPlaces(item) {
			console.log("fetch places")
			console.log(item)
			if(item.value) {
				var city = item.item;
				if(city.placesLoaded == false) {
					await this.getPlaces(city.id, city);
					city.placesLoaded = true;
					city.place = city.places.length;
					console.log('city');
				}
			}
		},
		addCountry() {
			this.newName = null;
			this.countryID = null;
			this.showAddNewCountry = true;
		},
		addNewCountry() {
			this.actionLoading = true;
			var data = {
				countryID: this.countryID,
				name: this.newName
			}

			clientNotifier
				.post("/api/location/addCountry", data)
				.then(response => {
					console.log(response);
					this.actionLoading = false;
					this.showAddNewCountry = false
					this.countries.push({
						country: response.data.data.name,
						countryID: response.data.data.countryID,
						id: response.data.data.countryID,
						name: response.data.data.name,
						regionsLoaded: false,
						regions: [],
					})
				})
				.catch(() => {
					this.actionLoading = false;
				});
		},
		addRegion(countryID) {
			this.newName = null;
			this.regionID = null;
			this.countryID = countryID;
			this.showAddNewRegion = true;
		},
		addNewRegion() {
			this.actionLoading = true;
			var data = {
				countryID: this.countryID,
				regionID: `${this.regionID}.${this.countryID}`,
				name: this.newName
			}

			var country = this.countries.find(country => country.id == this.countryID);

			clientNotifier
				.post("/api/location/addRegion", data)
				.then(response => {
					console.log(response);
					this.actionLoading = false;
					this.showAddNewRegion = false
					country.regions.push({
						id: response.data.data.regionID,
						regionID: response.data.data.regionID,
						country: country.country,
						region: response.data.data.name,
						citiesLoaded: false,
						cities: [],
					})
					if(country.region != null){
						country.region++
					}
				})
				.catch(err => {
					console.log(err);
					this.actionLoading = false;
				});
		},
		addCity(country, region) {
			this.newName = null;
			this.cityID = null;
			this.regionID = region.regionID;
			this.addingCityToRegion = region;
			this.addingToCountry = country;
			this.showAddNewCity = true;
		},
		addNewCity() {
			this.actionLoading = true;
			var data = {
				regionID: this.regionID,
				cityID: `${this.cityID}.${this.regionID}`,
				name: this.newName
			}

			var region = this.addingCityToRegion;
			var country = this.addingToCountry

			clientNotifier
				.post("/api/location/addCity", data)
				.then(response => {
					console.log(response);
					this.actionLoading = false;
					this.showAddNewCity = false
					region.cities.push({
						cityID: response.data.data.cityID,
						id: response.data.data.cityID,
						country: country.name,
						name: country.name,
						regionID: response.data.data.regionID,
						region: region.name,
						city: response.data.data.name,
					})
					if(region.city != null){
						region.city++
					}
				})
				.catch(err => {
					console.log(err);
					this.actionLoading = false;
				});
		},
		addPlace(country, region, city) {
			this.newName = null;
			this.placeID = null;
			this.cityID = city.cityID;
			this.addingToCity = city;
			this.addingCityToRegion = region;
			this.addingToCountry = country;
			this.showAddNewPlace = true;
		},
		addNewPlace() {
			this.actionLoading = true;
			var data = {
				cityID: this.cityID,
				name: this.newName,
				isHospital: this.isHospital,
				locationLink: this.locationLink
			}

			var region = this.addingCityToRegion;
			var country = this.addingToCountry
			var city = this.addingToCity;

			clientNotifier
				.post("/api/location/addPlace", data)
				.then(response => {
					console.log(response);
					this.actionLoading = false;
					this.showAddNewPlace = false
					city.places.push({
						placeID: response.data.data.cityID,
						id: response.data.data.cityID,
						countryID: country.countryID,
						country: country.name,
						regionID: region.regionID,
						region: region.name,
						cityID: city.cityID,
						city: city.name,
						place: response.data.data.name,
					})
					if (city.place != null) {
						city.place++
					}
				})
				.catch(err => {
					console.log(err);
					this.actionLoading = false;
				});
		},
		editCountry(country){
			this.newName = country.country;
			this.countryID = country.countryID;
			this.edittingCountry = country
			this.showEditCountry = true;
		},
		editRegion(region){
			this.newName = region.region;
			this.regionID = region.regionID;
			this.countryID = region.countryID;
			this.edittingRegion = region
			this.showEditRegion = true;
		},
		editCity(city){
			this.newName = city.city;
			this.cityID = city.cityID;
			this.regionID = city.regionID;
			this.edittingCity = city
			this.showEditCity = true;
		},
		editPlace(place){
			this.newName = place.place;
			this.placeID = place.placeID;
			this.cityID = place.cityID;
			this.edittingPlace = place
			this.showEditPlace = true;
		},
		updateCountry(){
			this.actionLoading = true;
			var data = {
				countryID: this.countryID,
				name: this.newName
			}

			clientNotifier
				.post("/api/location/updateCountry", data)
				.then(response => {
					console.log(response);
					this.actionLoading = false;
					this.showEditCountry = false
					this.edittingCountry.country = response.data.data.name
				})
				.catch(err => {
					console.log(err);
					this.actionLoading = false;
				});
		},
		updateRegion(){
			this.actionLoading = true;
			var data = {
				countryID: this.countryID,
				regionID: this.regionID,
				name: this.newName
			}

			clientNotifier
				.post("/api/location/updateRegion", data)
				.then(response => {
					console.log(response);
					this.actionLoading = false;
					this.showEditRegion = false
					this.edittingRegion.region = response.data.data.name
				})
				.catch(err => {
					console.log(err);
					this.actionLoading = false;
				});
		},
		updateCity(){
			this.actionLoading = true;
			var data = {
				regionID: this.regionID,
				cityID: this.cityID,
				name: this.newName
			}

			// var region = this.addingCityToRegion;
			// var country = this.addingToCountry

			clientNotifier
				.post("/api/location/updateCity", data)
				.then(response => {
					console.log(response);
					this.actionLoading = false;
					this.showEditCity = false
					this.edittingCity.city = response.data.data.name
				})
				.catch(err => {
					console.log(err);
					this.actionLoading = false;
				});
		},
		updatePlace(){
			this.actionLoading = true;
			var data = {
				cityID: this.cityID,
				name: this.newName,
				isHospital: this.isHospital,
				locationLink: this.locationLink
			}

			clientNotifier
				.post("/api/location/updateHospital", data)
				.then(response => {
					console.log(response);
					this.actionLoading = false;
					this.showEditPlace = false
					this.edittingPlace.place = response.data.data.name
				})
				.catch(err => {
					console.log(err);
					this.actionLoading = false;
				});
		},
		async removeCountry(country, confirmed = false) {
			if (confirmed == false) {
				const confirmed = await this.$refs.confirm.open({
					title: "تأكيد الحذف",
					message: "هل تريد حقاً حذف هذه الدولة" }
				);
				if (confirmed) {
					this.removeCountry(country, true)
				}
				return;
			}

			this.actionLoading = true;

			clientNotifier
				.delete("/api/location/deleteCountry/" + country.countryID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");
					this.getCountries();
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.actionLoading = false;
				});
		},
		async removeRegion(region, confirmed = false) {
			if (confirmed == false) {
				const confirmed = await this.$refs.confirm.open({
					title: "تأكيد الحذف",
					message: "هل تريد حقاً حذف هذه المنطقة" }
				);
				if (confirmed) {
					this.removeRegion(region, true)
				}
				return;
			}

			this.actionLoading = true;

			clientNotifier
				.delete("/api/location/deleteRegion/" + region.regionID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");
					const country = this.countries.find(country => country.countryID == region.countryID)
					this.getRegions(region.countryID, country);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.actionLoading = false;
				});
		},
		async removeCity(city, region, confirmed = false) {
			if (confirmed == false) {
				const confirmed = await this.$refs.confirm.open({
					title: "تأكيد الحذف",
					message: "هل تريد حقاً حذف هذه المدينة" }
				);
				if (confirmed) {
					this.removeCity(city, region, true)
				}
				return;
			}

			this.actionLoading = true;

			clientNotifier
				.delete("/api/location/deleteCity/" + city.cityID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");
					this.getCities(region.regionID, region);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.actionLoading = false;
				});
		},

		async removePlace(city, place, confirmed = false) {
			console.log(place)
			if (confirmed == false) {
				const confirmed = await this.$refs.confirm.open({
					title: "تأكيد الحذف",
					message: "هل تريد حقاً حذف هذا المكان" }
				);
				if (confirmed) {
					this.removePlace(city, place, true)
				}
				return;
			}

			this.actionLoading = true;

			clientNotifier
				.delete("/api/location/deletePlace/" + place.id)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");
					this.getPlaces(city.cityID, city);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.actionLoading = false;
				});
		},
	}
};
</script>

<style scoped>
::v-deep .v-data-table__expanded .v-data-table-header.v-data-table-header-mobile {
	display: none;
}

::v-deep td.text-start:nth-child(1) {
	width: 0px;
}
::v-deep td.text-start:nth-child(2) {
    width: 20%;
}
::v-deep td.text-start:nth-child(3) {
    width: 20%;
}
::v-deep td.text-start:nth-child(4) {
    width: 20%;
}
::v-deep td.text-start:nth-child(5) {
    width: 20%;
}
::v-deep td.text-start:nth-child(5) {
    width: 20%;
}

.theme--light.v-data-table .v-data-table {
    background-color: hsl(0, 0%, 97%);
}

.theme--light.v-data-table .v-data-table .v-data-table {
    background-color: hsl(0, 0%, 94%)
}

.theme--light.v-data-table .v-data-table .v-data-table .v-data-table {
    background-color: hsl(0, 0%, 91%)
}

.v-data-table .v-data-table {
    border-radius: 0;
}
</style>